/**
 * 대상 날짜까지 남은 시간을 계산합니다.
 * @param {Date} targetDate - 목표 날짜 및 시간
 * @returns {{ days: number, hours: number, minutes: number, seconds: number }} 남은 시간 객체
 */
export const calculateTimeLeft = (targetDate) => {
  const now = new Date();
  const difference = targetDate - now;

  // 기본값: 남은 시간이 없는 경우
  const defaultResult = { days: 0, hours: 0, minutes: 0, seconds: 0 };

  // 날짜가 이미 지났거나 유효하지 않은 경우
  if (difference <= 0 || isNaN(difference)) {
    return defaultResult;
  }

  // 남은 시간 계산
  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((difference / 1000 / 60) % 60);
  const seconds = Math.floor((difference / 1000) % 60);

  return { days, hours, minutes, seconds };
};

/**
 * 숫자 값을 지정된 길이의 문자열로 변환하고, 필요한 경우 앞에 0을 추가합니다.
 * @param {number} value - 변환할 숫자
 * @param {number} length - 결과 문자열의 길이 (기본값: 2)
 * @returns {string} 변환된 문자열
 */
export const padNumber = (value, length = 2) => {
  return String(value).padStart(length, '0');
}; 